<template>
  <div id="app">
    <div
      :class="[
        'g-cursor',
        { 'g-cursor_hover': hover },
        { 'g-cursor_hide': hideCursor }
      ]"
    >
      <div :style="cursorCircle" class="g-cursor__circle"></div>
      <div class="g-cursor__point" ref="point" :style="cursorPoint"></div>
    </div>
    <Loader :loaded="loaded" v-if="loadState" />
    <!-- <div class="mover">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="181.845"
        height="181.845"
        viewBox="0 0 181.845 181.845"
      >
        <g transform="translate(1.466 1.466)">
          <g transform="translate(-0.735 89.925) rotate(-45)">
            <g transform="translate(0.52 0.52)">
              <path
                d="M64.107.52l-34.729,10.2L5.672,38.076.52,73.91l15.033,32.918L46,126.409H82.2l30.451-19.581L127.693,73.91l-5.152-35.834L98.836,10.722Z"
                transform="translate(-0.52 -0.52)"
                fill="none"
                stroke="#8d140e"
                stroke-miterlimit="10"
                stroke-width="2"
              />
              <line
                x1="78.375"
                transform="translate(22.035 62.944)"
                fill="none"
                stroke="#8d140e"
                stroke-miterlimit="10"
                stroke-width="3"
              />
              <path
                d="M46.26,31.52v8.351l27.945,9.315H87.9V57.2"
                transform="translate(12.509 8.31)"
                fill="none"
                stroke="#8d140e"
                stroke-miterlimit="10"
                stroke-width="3"
              />
              <path
                d="M46.26,73.194V64.842l27.945-9.315H87.9V47.51"
                transform="translate(12.509 12.865)"
                fill="none"
                stroke="#8d140e"
                stroke-miterlimit="10"
                stroke-width="3"
              />
            </g>
          </g>
        </g>
      </svg>
    </div> -->
    <!-- <transition name="fade"> -->
    <Menu></Menu>

    <div class="full-home initial-display">
      <Home id="Home"></Home>
      <Projects id="Projects"></Projects>
      <About></About>
      <Contact></Contact>
      <Footer></Footer>
    </div>
    <!-- </transition> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Home from "./views/Home";
import Projects from "./views/Projects";
import About from "./views/About";
import Contact from "./views/Contact";
import Footer from "./views/Footer";
import Menu from "./views/Menu";
import Loader from "./components/loader";
import { mapMutations } from 'vuex';
export default {
  name: "App",
  components: {
    Home,
    Projects,
    About,
    Contact,
    Footer,
    Menu,
    Loader
  },
  data() {
    return {
      loadingPercent: 0,
      loadTime: 0,
      interval: null,
      xChild: 0,
      yChild: 0,
      xParent: 0,
      yParent: 0,
      hover: false,
      hideCursor: true
    };
  },
  computed: {
    menuclose() {
      return this.$store.state.menu;
    },
    loaded() {
      return this.loadingPercent;
    },
    loadState() {
      return this.loadingPercent < 100;
    },
    cursorCircle() {
      return `transform: translateX(${this.xParent}px) translateY(${this.yParent}px) translateZ(0) translate3d(0, 0, 0);`;
    },
    cursorPoint() {
      return `transform: translateX(${this.xChild - 3}px) translateY(${this
        .yChild - 3}px) translateZ(0) translate3d(0, 0, 0);`;
    }
  },
  watch: {
    loadingPercent(val) {
      if (val >= 100) {
        let home = document.querySelector(".full-home");
        home.style.height = "100%";
        clearInterval(this.interval);
				this.updateSiteLoaded(true);
      }
    }
  },
  mounted() {
    document.addEventListener("mousemove", this.moveCursor);
    document.addEventListener("mouseleave", () => {
      this.hideCursor = true;
    });
    document.addEventListener("mouseenter", () => {
      this.hideCursor = false;
    });
  },
  created() {
    let perfData = window.performance.timing;
    let estimatedTime = Math.abs(
      perfData.loadEventEnd - perfData.navigationStart
    );
    this.loadTime = parseInt((estimatedTime / 1000) % 60) * 100;
    this.doProgress();
  },
  methods: {
    doProgress() {
      let step = this.loadTime / 100;
      this.interval = setInterval(() => {
        this.loadingPercent++;
      }, step);
    },
    moveCursor(e) {
      this.xChild = e.clientX;
      this.yChild = e.clientY;
      setTimeout(() => {
        this.xParent = e.clientX - 15;
        this.yParent = e.clientY - 15;
      }, 100);
    },
			...mapMutations([
			'updateSiteLoaded', //also supports payload `this.nameOfMutation(amount)` 
		])
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Work+Sans:500,600&display=swap");
@font-face {
  font-family: "sharpe";
  src: url("./assets/Sharpe personal/SharpeMe_PERSONAL.ttf");
}
body {
  margin: 0;
  overflow-x: hidden;
	  cursor: none;
  // cursor: url("./assets/logo.png") auto;
}
html {
	  cursor: none;
  /* cursor: url(/assets/svgs/cursor.png) 6 6 auto; */
}
/* .mover {
  width: 5px;
  height: 5px;
  position: absolute;
  left: var(--mouse-x);
  top: var(--mouse-y);
  z-index: 9999;
}
.mover svg {
  width: 80px;
  height: auto;
}
html {
  cursor: none;
} */
html::-webkit-scrollbar {
  display: none;
}

html::-moz-scrollbar {
  display: none;
}

::-ms-overflow-style {
  display: none;
}
#app {
  font-family: "Work Sans", sans-serif;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #13120d;
  overflow-x: hidden;
}
a {
  transition: all 0.2s linear;
}
a:hover {
  color: #8d140e !important;
  text-decoration: none !important;
  /* letter-spacing: 2px; */
  transition: all 0.2s linear;
}
h1,
h2,
h3,
h4 {
  font-family: "sharpe", sans-serif;
}
h1 {
  /* font-size:200px!important; */
  font-size: 11rem !important;
}
h2 {
  font-size: 70px !important;
  line-height: 90px !important;
}
.p {
  font-size: 14px;
  line-height: 35px;
}
.max-width-p {
  max-width: 400px;
}
.thick-text {
  font-size: 24px;
  font-weight: bold;
}
.medium-h-text {
  font-size: 20px;
}
.bold-text {
  font-weight: bold;
}
.bolden-text {
  font-weight: 600;
}
.pale-bg {
  background-color: rgba(239, 238, 235, 1);
}
.gradient-bg {
  background-image: linear-gradient(180deg, #fcfcfc, rgba(239, 238, 235, 1));
}
.trans-bg {
  background-color: transparent;
}
.red-shadow {
  -webkit-box-shadow: -4px 52px 77px -21px rgba(113, 32, 28, 0.2);
  -moz-box-shadow: -4px 52px 77px -21px rgba(113, 32, 28, 0.2);
  box-shadow: -4px 52px 77px -21px rgba(113, 32, 28, 0.2);
}
.red-text {
  color: #8d140e !important;
}
.black-text {
  color: #13120d;
}
.cream-text {
  color: #ffa176;
}
.white-text {
  color: #fcfcfc;
}
.medium-font {
  font-size: 15px;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.6s ease-in;
  /* background-color: #8d140e; */
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0.1;
  background-color: #8d140e;
}
.full-home {
  height: 100vh;
}
.initial-display {
  position: relative;
  z-index: 2;
}
.show-display {
  position: relative !important;
  z-index: 2 !important;
  /* animation: slideDown 5s ease-in-out; */
  -webkit-animation: fadeIn 0.5s ease-in;
  animation: fadeIn 0.5s ease-in;
  /* opacity:1;
	transition: all 0.6s ease-in-out; */
}
.hide-display {
  position: absolute !important;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1 !important;
  height: 100vh;
  overflow-y: hidden !important;
  /* display: none; */
  /* animation: fadeOut 5s ease-in-out; */
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.5;
  }
  70% {
    opacity: 0.7;
  }
  90% {
    opacity: 0.9;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.5;
  }
  70% {
    opacity: 0.7;
  }
  90% {
    opacity: 0.9;
  }
  100% {
    opacity: 1;
  }
}
.g-cursor {
  &_hide {
    opacity: 0;
    transition: width 0.6s ease, height 0.6s ease, opacity 0.6s ease;
  }

  &__circle {
    pointer-events: none;
    user-select: none;
    top: 0;
    left: 0;
    position: fixed;
    width: 30px;
    height: 30px;
    border: 2px solid #71201c;
    border-radius: 100%;
    z-index: 5555;
    backface-visibility: hidden;
    transition: opacity 0.6s ease;
  }

  &__point {
    top: 0;
    left: 0;
    position: fixed;
    width: 10px;
    height: 10px;
    pointer-events: none;
    user-select: none;
    border-radius: 100%;
    background: #71201c;
    z-index: 55555555;
    backface-visibility: hidden;
    will-change: transform;
  }

  &_hover {
    .g-cursor__circle {
      opacity: 0;
      width: 60px;
      height: 60px;
      transition: width 0.6s ease, height 0.6s ease, opacity 0.6s ease;
    }
  }
}

@media only screen and (max-width: 768px) {
  h1 {
    font-size: 130px !important;
    /* font-size: 6rem !important; */
  }
  h2 {
    font-size: 35px !important;
    line-height: 60px !important;
  }
  h3 {
    font-size: 25px !important;
  }
	.g-cursor {
		/* opacity: 0; */
	}
}

@media only screen and (min-width: 768px) and (max-width: 999px) {
  h1 {
    font-size: 100px !important;
    /* font-size: 6rem !important; */
  }
  h2 {
    font-size: 30px !important;
    line-height: 60px !important;
  }
  h3 {
    font-size: 20px !important;
  }
}
</style>
